import { Auth } from 'aws-amplify';

export const environment = {
  cognitoConfiguration: {
      Auth: {
          // (required)- Amazon Cognito Region
          region: 'ca-central-1',
          userPoolId: window.env.amplifyConfig.user_pool_id, //"ca-central-1_jiv4WwwQL",
          userPoolWebClientId: window.env.amplifyConfig.user_pool_web_client_id,   //"9otmpd738ru9i07gvc500fl1e",
          authenticationFlowType: "USER_SRP_AUTH",
          oauth: {
              name: window.env.amplifyConfig.oauth_name,  //"bag",
              domain: window.env.amplifyConfig.oauth_domain,  //"ace-portal-dev.auth.ca-central-1.amazoncognito.com",
              scope: ["openid", "profile"],
              redirectSignIn: window.location.protocol + "//" + window.location.host + "/callback",
              redirectSignOut: window.env.amplifyConfig.signOut_url,
              responseType: "code"
          }
      },
      "API": {
          "endpoints": [
              {
                  "name": "backend-api",
                  "endpoint": window.env.amplifyConfig.api_endpoint,  //"https://ace-dev.dev.cbsa-asfc.cloud-nuage.canada.ca/api/",
                  "custom_header": async () => {
                    const jwToken = `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`;
                    return {
                      "content-type" : "application/json",
                      "Authorization": jwToken
                    };
                  }
              }
              , {
                  "name": "fileUpload-api",
                  "endpoint": window.env.amplifyConfig.fileUpload_endpoint,  //"https://ace-dev.dev.cbsa-asfc.cloud-nuage.canada.ca/fileUpload",
                  "custom_header": async () => {
                    const jwToken = `Bearer ${(await Auth.currentSession()).getAccessToken().getJwtToken()}`;
                    return {
                      "Authorization": jwToken
                    };
                  }
              }
              , {
                  "name": "anon-exhibits-api",	//used for calling the exhibits lambda that doesn't require authentication
                  "endpoint": window.env.amplifyConfig.api_endpoint  //"https://ace-dev.dev.cbsa-asfc.cloud-nuage.canada.ca/api/",
              }
          ]

      }
  }
};